import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Stack,
  Button,
  Slide
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/bjk-dernek-logo.png";
import { useLocation } from "react-router-dom";

function MobileHeader() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };
  const location = useLocation();

  const menuItems = [
    { text: "ANA SAYFA", link: "/" },
    { text: "HAKKIMIZDA", link: "/hakkimizda" },
    { text: "ÜYELERİMİZ", link: "/uyeler" },
    { text: "ETKİNLİKLER", link: "/etkinlikler" },
    { text: "İLETİŞİM", link: "/iletisim" },
    { text: "KURULLAR", link: "/kurullar" },
    { text: "ÜYELİK", link: "/uyelik" }
  ];

  return (
    <AppBar
      position='fixed'
      sx={{
        backgroundColor: "rgb(255, 255, 255)",
        boxShadow: "0px 4prgb(255, 255, 255)0.2)"
      }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <IconButton
          edge='start'
          color='inherit'
          aria-label='menu'
          onClick={handleDrawerToggle}
          sx={{ color: "black" }}>
          <MenuIcon />
        </IconButton>

        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            margin: "0 auto"
          }}>
          <Link
            to='/'
            style={{
              display: "flex",
              alignItems: "center",
              margin: " -5em 1em -4em -2em"
            }}>
            <img
              src={Logo}
              alt='Besiktasli-doktorlar-dernegi-logo'
              style={{
                width: "100%", // Genişliği %100 yaparak ekranın genişliğine uyum sağlar
                maxWidth: "300px", // 150px'yi geçmemesini sağla
                height: "auto" // Yükseklik oranı bozulmasın
              }}
            />
          </Link>
        </Box>

        {/* <Box sx={{ flexGrow: 0 }}>
        <Button>
            <span className="B-18">Giriş</span>
          </Button>
        </Box> */}

        <Drawer anchor='left' open={drawerOpen} onClose={handleDrawerToggle}>
          <Slide direction='right' in={drawerOpen} mountOnEnter unmountOnExit>
            <Stack spacing={10} width={200}>
              <IconButton
                edge='end'
                color='inherit'
                aria-label='close'
                onClick={handleDrawerToggle}
                sx={{ position: "absolute", right: 8, top: 16 }}>
                <CloseIcon />
              </IconButton>
              <Stack spacing={2}>
                {menuItems.map((item, index) => (
                  <Link
                    to={item.link}
                    key={index}
                    onClick={handleDrawerToggle}
                    style={{ textDecoration: "none", width: "100%" }}>
                    <Button
                      sx={{
                        width: "100%",
                        justifyContent: "center",
                        textAlign: "center"
                      }}>
                      <span
                        className={
                          location.pathname === item.link ? "B-18-bold" : "B-18"
                        }
                        style={{ width: "100%" }}>
                        {item.text}
                      </span>
                    </Button>
                  </Link>
                ))}
              </Stack>
            </Stack>
          </Slide>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
}

export default MobileHeader;
